module.exports = __webpack_public_path__ + "static/media/4 1 Skrivehastighet Intro.6bf36d27.mp3";